<div class="box-theme">
  <!--<div class="head">
    <div class="header">
      <div class="ico">
        <img src="./assets/img/icon-13-1.png">
      </div>
    </div>
    <div class="body">
      <h2>Beneficio clientes vulnerables Covid-19</h2>
      <p>Postergación del pago de deuda por contingencia Covid-19, a pagar hasta en 12 cuotas sin interés</p>
    </div>
  </div>-->
  <div class="body">
    <!-- PASO NUMERO 1 -->
    <div class="paso-1">
      <div class="header">
        <h3>
          Si usted es cliente residencial con uno de estos perfiles, <br/>
          puede solicitar Beneficio Covid-19, que le permitirá acceder a la <br/>
          postergación del pago de su cuenta hasta en 12 cuotas sin interés. 
        </h3>
      </div>
      <div class="body-p1">
        <ul class="thumbs-covid-19">
          <li>
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <img src="./assets/img/covid19-1.png" />
              </div>
            </div>
            <!--<div class="card">
              <div class="head">
                <div class="icono">
                  <img src="./assets/img/icon-13.png" />
                </div>
              </div>
              <div class="body">
                <h2>
                  Hogar vulnerable<br>
                  con ficha RSH
                </h2>
              </div>
            </div>-->
          </li>
          <li>
            <!--<div class="card">
              <div class="head">
                <div class="icono">
                  <img src="./assets/img/icon-13-2.png" />
                </div>
              </div>
              <div class="body">
                <h2>
                  Adulto mayor<br>
                  de 60 años
                </h2>
              </div>
            </div>-->
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <img src="./assets/img/covid19-2.png" />
              </div>
            </div>
          </li>
          <li>
            <!--<div class="card">
              <div class="head">
                <div class="icono">
                  <img src="./assets/img/icon-13-3.png" />
                </div>
              </div>
              <div class="body">
                <h2>
                  Persona percibiendo<br>
                  seguro de desempleo
                </h2>
              </div>
            </div>-->
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <img src="./assets/img/covid19-3.png" />
              </div>
            </div>
          </li>
          <li>
            <!--<div class="card">
              <div class="head">
                <div class="icono">
                  <img src="./assets/img/icon-13-4.png" />
                </div>
              </div>
              <div class="body">
                <h2>
                  Suspensión o reducción<br>
                  jornada laboral
                </h2>
              </div>
            </div>-->
            <div class="card">
              <div class="text-center contenedor-card-beneficio">
                <img src="./assets/img/covid19-4.png" />
              </div>
            </div>
          </li>
        </ul>
        <div class="documentos-solicitados">
          <table class="escritorio">
            <tr class="titulo-tabla sin-borde">
              <td>&nbsp;</td>
              <td colspan="4"><h3>Perfiles</h3></td>
            </tr>
            <tr class="titulo-tabla perfiles">
              <td class="documentos-requeridos"><h3>Documentos requeridos para solicitar beneficio</h3></td>
              <td>Hogar <br>vulnerable</td>
              <td>Adulto <br>mayor</td>
              <td>Percibiendo <br>seguro <br>desempleo</td>
              <td>Suspensión o <br>reducción <br>jornada laboral</td>
            </tr>
            <tr class="documentos">
              <td>
                Imagen de la cédula de identidad por ambos lados.
              </td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
            </tr>
            <tr class="documentos">
              <td>
                Copia de ficha en Registro Social que demuestre que se encuentra en el 40% de hogares más vulnerables. Si no tiene este documento, obtenlo en <a href="http://www.registrosocial.gob.cl/" target="_blank" rel="noopener noreferrer">http://www.registrosocial.gob.cl/</a>
              </td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr class="documentos">
              <td>
                Copia de documento a nombre del solicitante que acredite residencia en el domicilio (ejemplo: contrato de arriendo,  boletas de servicios de telefonía móvil u otros).
              </td>
              <td>&nbsp;</td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
            </tr>
            <tr class="documentos">
              <td>
                Declaración jurada simple que señale la situación que justifique la postergación.
              </td>
              <td>&nbsp;</td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td>&nbsp;</td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
            </tr>
            <tr class="documentos">
              <td>
                Comprobante de activación de seguro de cesantía.
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
              <td>&nbsp;</td>
            </tr>
            <tr class="documentos">
              <td>
                Anexo de contrato de trabajo que acredite reducción o suspensión de relación laboral.
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td class="text-center"><img src="./assets/img/check.png" alt="check-documento"></td>
            </tr>
          </table>
          <div class="mobile">
            <h3>Documentos requeridos para solicitar beneficio según el perfil</h3>

            <div>
              <h4>Hogar vulnerable</h4>
              <div class="contenedor-documentos">
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Imagen de la cédula de identidad por ambos lados.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Copia de ficha en Registro Social que demuestre que se encuentra en el 40% de hogares más vulnerables. 
                    Si no tiene este documento, obtenlo en <a href="http://www.registrosocial.gob.cl/" target="_blank" rel="noopener noreferrer">http://www.registrosocial.gob.cl/</a>
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4>Adulto mayor</h4>
              <div class="contenedor-documentos">
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Imagen de la cédula de identidad por ambos lados.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Copia de documento a nombre del solicitante que acredite residencia en el domicilio (ejemplo: contrato de arriendo,  boletas de servicios de telefonía móvil u otros).
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Declaración jurada simple que señale la situación que justifique la postergación.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4>Percibiendo seguro desempleo</h4>
              <div class="contenedor-documentos">
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Imagen de la cédula de identidad por ambos lados.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Copia de documento a nombre del solicitante que acredite residencia en el domicilio (ejemplo: contrato de arriendo,  boletas de servicios de telefonía móvil u otros).
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Comprobante de activación de seguro de cesantía.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4>Suspensión o reducción jornada laboral</h4>
              <div class="contenedor-documentos">
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Imagen de la cédula de identidad por ambos lados.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Copia de documento a nombre del solicitante que acredite residencia en el domicilio (ejemplo: contrato de arriendo,  boletas de servicios de telefonía móvil u otros).
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Declaración jurada simple que señale la situación que justifique la postergación.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
                <div class="div-documentos">
                  <div class="nombre-documento">
                    Anexo de contrato de trabajo que acredite reducción o suspensión de relación laboral.
                  </div>
                  <div class="check">
                    <img src="./assets/img/check.png" alt="check-documento">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="observaciones">
            <p class="comentario-destacado">
              Si cumple con estos requisitos y cuenta con los documentos indicados, solicite el beneficio llamando al 600 337 8000, 
              de lunes a viernes de 09 a 19 horas (excepto festivos). 
            </p>
          </div>
        </div>
        <div class="preguntas-frecuentes">
          <div class="header">
            <h3>Conoce en detalle en qué consiste el Beneficio Covid-19 de Metrogas</h3>
          </div>
          <div class="body">
            <ngb-accordion #acc="ngbAccordion" [destroyOnHide]="false" activeIds="config-panel-one">
              <ngb-panel id="pregunta-1">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">1</p>
                    <p class="texto">¿En qué consiste el beneficio de postergación de pagos por contingencia Covid-19?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    El beneficio consiste en que las cuentas por consumo de gas, desde el 19 de marzo y hasta el 16 de septiembre de 2020, se pueden postergar, 
                    para pagarse hasta en 12 cuotas iguales y sucesivas, sin ningún tipo de multas ni intereses.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-2">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">2</p>
                    <p class="texto">Si tengo deuda previa, ¿me puedo acoger a este beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Sí, puede acogerse a este beneficio siempre y cuando la deuda previa no supere las 5 UF.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-3">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">3</p>
                    <p class="texto">¿Qué pasa si mi deuda vencida es mayor a las 5 UF?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Puede realizar la solicitud, adjuntando los respaldos correspondientes. Metrogas evaluará la situación particular.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-4">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">4</p>
                    <p class="texto">¿Qué pasa si yo ya solicité un plan de pago antes de la vigencia de este beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    El plan de pago se considera una deuda previa, por lo que puede solicitar este beneficio y Metrogas evaluará su situación particular.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-5">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">5</p>
                    <p class="texto">¿Quiénes pueden acceder a este beneficio?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Este beneficio puede ser solicitado por los clientes residenciales activos que cumplan, a lo menos, con uno de los siguientes requisitos:
                  </p>
                  <p>
                    <strong>a)</strong> Pertenecer al 40% de hogares de mayor vulnerabilidad, de acuerdo al Registro Nacional de Hogares del Ministerio de Desarrollo Social.
                  </p>
                  <p>
                    <strong>b)</strong> Ser adulto mayor, es decir, tener más de 60 años de edad, y acreditar alguna condición que demuestre imposibilidad de pago de cuenta de gas.
                  </p>
                  <p>
                    <strong>c)</strong> Estar recibiendo las prestaciones del Seguro de Cesantía de la Ley N°19.728.
                  </p>
                  <p>
                    <strong>d)</strong> Estar acogido a alguna de las causales establecidas en la Ley N°21.227 (Ley de Protección al empleo Covid-19), ya sea por la suspensión 
                    de la relación laboral, o por una reducción temporal de jornada de trabajo; y acreditar condición que demuestre imposibilidad de pago de cuenta de gas.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pregunta-6">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">6</p>
                    <p class="texto">¿Cómo puedo solicitar el beneficio y qué antecedentes se requieren?</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    Para solicitar el beneficio debe llamar al 600 337 8000; de lunes a viernes de 9 a 19 horas, excepto festivos. Posterior al contacto con ejecutivo, 
                      se debe enviar por correo electrónico la documentación que acredite que cumple con alguno de los requisitos señalados anteriormente. 
                  </p>
                </ng-template>
              </ngb-panel>
              <!--<ngb-panel id="pregunta-6">
                <ng-template ngbPanelTitle>
                  <div class="titulo">
                    <p class="numero">6</p>
                    <p class="texto">Otras preguntas frecuentes</p>
                    <div class="expande">
                      <label for="collapsible" class="lbl-toggle"></label>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Cómo puedo solicitar el beneficio y qué antecedentes se requieren?
                    </p>
                    <p class="p-respuesta">
                      Para solicitar el beneficio debe llamar al 600 337 8000; de lunes a viernes de 9 a 19 horas, excepto festivos. Posterior al contacto con ejecutivo, 
                      se debe enviar por correo electrónico la documentación que acredite que cumple con alguno de los requisitos señalados anteriormente. 
                    </p>
                  </div>
                  
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Hasta cuándo puedo solicitar este beneficio?
                    </p>
                    <p class="p-respuesta">
                      Puede solicitar el beneficio por un período de hasta 90 días a contar del 19 de marzo de 2020, es decir hasta las 23:59 horas del 18 de junio de 2020.
                    </p>
                  </div>
                  
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Cuánto tiempo se demoran en contestar la solicitud de postergación de pagos por contingencia Covid-19?
                    </p>
                    <p class="p-respuesta">
                      Una vez recibida la documentación requerida, en un plazo de 5 días hábiles se entregará la respuesta a la solicitud.
                    </p>
                  </div>
                    
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Por qué podrían rechazarme la solicitud?
                    </p>
                    <p class="p-respuesta">
                      Por no acreditar alguno de los requisitos para acceder a este beneficio.
                    </p>
                  </div>
                    
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      Si recibo el beneficio de postergación en el pago de cuentas, ¿cuándo comenzarán a cobrar las cuotas?
                    </p>
                    <p class="p-respuesta">
                      Las cuotas comenzarán a cobrarse en la primera facturación a partir del 19 de junio de 2020.
                    </p>
                  </div>
                    
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué significa postergar el pago de cuentas?
                    </p>
                    <p class="p-respuesta">
                      Postergar la cuenta es aplazar el pago de la facturación de gas que se haya originado durante el período comprendido entre el 19 de marzo de 2020 y el 
                      18 de junio de 2020.
                    </p>
                  </div>
                    
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿La postergación es un beneficio automático?
                    </p>
                    <p class="p-respuesta">
                      La postergación no es un beneficio automático. Por ello debe ser solicitado por el cliente, cumplir con los requisitos indicados anteriormente, 
                      y ser aceptado por la empresa para su otorgamiento.
                    </p>
                  </div>
                    
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué diferencia hay entre postergar y negociar una deuda?
                    </p>
                    <p class="p-respuesta">
                      Postergar es el beneficio que permite, a quienes cumplen con los requisitos anteriormente descritos, aplazar el pago de la cuenta de gas, 
                      sin multas ni intereses en el contexto de la contingencia por Covid-19. Por su parte, negociar es un beneficio permanente que ofrece Metrogas, 
                      que permite en situaciones particulares, acordar condiciones de pago, tales como monto de pie y número de cuotas para pagar una deuda.
                    </p>
                  </div>
                    
                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué ocurre una vez finalizado el plazo de postergación? 
                    </p>
                    <p class="p-respuesta">
                      Terminado el plazo de postergación de pago, recibirá una boleta de gas que incluirá el monto del consumo del mes más la primera cuota sin interés 
                      por la cuenta postergada, la cual deberá ser pagada en el plazo establecido por la ley.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿Qué es una declaración jurada simple?
                    </p>
                    <p class="p-respuesta">
                      La Declaración Jurada Simple es un documento mediante el cual una persona realiza una declaración relativa a un hecho o entrega información 
                      respecto del mismo, bajo la responsabilidad de que la información entregada es verdadera y fidedigna.
                    </p>
                    <p class="p-respuesta">
                      Esta puede ser manuscrita o impresa, y no requiere la firma de un notario público.
                    </p>
                  </div>

                  <div class="contenedor-otras-preguntas">
                    <p class="p-pregunta">
                      ¿La deuda postergada radicará en la propiedad?
                    </p>
                    <p class="p-respuesta">
                      Sí, las obligaciones derivadas del servicio de gas se radicarán en el inmueble, en conformidad a lo dispuesto en la normativa vigente, cuando corresponda.
                    </p>
                  </div>
                </ng-template>
              </ngb-panel>-->
            </ngb-accordion>
            <br><br>
            <div class="observaciones">
              <p class="comentario-destacado">
                Si cumple con estos requisitos y cuenta con los documentos indicados, solicite el beneficio llamando al 600 337 8000, 
                de lunes a viernes de 09 a 19 horas (excepto festivos). 
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>